var ButtonShapeEnum = /* @__PURE__ */ ((ButtonShapeEnum2) => {
  ButtonShapeEnum2["circle"] = "circle";
  ButtonShapeEnum2["round"] = "round";
  return ButtonShapeEnum2;
})(ButtonShapeEnum || {});

export { ButtonShapeEnum };
